export default __webpack_public_path__ + "static/media/linkedin.aac2bd0e.png";